import apiClient from './apiClient';
import { jwtDecode } from 'jwt-decode';

export const authService = {
  // Login with email and password
  login: async (email, password) => {
    const response = await apiClient.post('/api/medical-auth', {
      action: 'login',
      email,
      password,
    });
    return response.data;
  },

  // Verify OTP
  verifyOTP: async (email, token) => {
    const response = await apiClient.post('/api/medical-auth', {
      action: 'verify-otp',
      email,
      token,
    });
    return response.data;
  },

  // Logout
  logout: async (email) => {
    const response = await apiClient.post('/api/medical-auth', {
      action: 'logout',
      email,
    });
    localStorage.removeItem('medical-token');
    localStorage.removeItem('medical-user');
    return response.data;
  },

  // Check if user is authenticated and token is not expired
  isAuthenticated: () => {
    const token = localStorage.getItem('medical-token');
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      // If token is expired, clear storage and return false
      if (decoded.exp <= currentTime) {
        localStorage.removeItem('medical-token');
        localStorage.removeItem('medical-user');
        return false;
      }

      return true;
    } catch (error) {
      // If token is invalid, clear storage
      localStorage.removeItem('medical-token');
      localStorage.removeItem('medical-user');
      return false;
    }
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('medical-user');
    return userStr ? JSON.parse(userStr) : null;
  },
};
